<template>
	<div>
		<div v-if="form" class="modal_form">
			<div>
				<p class="bold">שם מועמד/ת</p>
				<input type="text" v-model="form.data.offer.fields.applicant_name.value" 
					   :class="{ field_error: form.data.offer.fields.applicant_name.has_error }"
					   @focus="form.data.offer.fields.applicant_name.has_error = false">
			</div>
			<div class="form_section">
				<p class="bold">חברה</p>
				<companies-search-box v-model="form.data.offer.fields.company_id.value" :selected_company_name="selected_company_name"></companies-search-box>
			</div>
			<div class="form_section">
				<p class="bold">שכר</p>
				<div class="flex flex_align_center">
					<input type="text" v-model="form.data.offer.fields.salary.value" 
						   :class="{ field_error: form.data.offer.fields.salary.has_error }"
						   @focus="form.data.offer.fields.salary.has_error = false">
					<div class="horizontal_space"></div>
					<checkbox v-model="form.data.offer.fields.salary_verified.value" :checked="form.data.offer.fields.salary_verified.value">
						מאושר
					</checkbox>
				</div>
			</div>
			<div class="form_section">
				<p class="bold">אחוז השמה</p>
				<div class="flex flex_align_center">
					<input type="text" v-model="form.data.offer.fields.percentage.value" 
						   :class="{ field_error: form.data.offer.fields.percentage.has_error }"
						   @focus="form.data.offer.fields.percentage.has_error = false">
					<div class="horizontal_space"></div>
					<checkbox v-model="form.data.offer.fields.percentage_verified.value" :checked="form.data.offer.fields.percentage_verified.value">
						מאושר
					</checkbox>
					<div class="percentage_different" v-if="!payload.is_create && form.data.offer.fields.percentage.value != payload.data.company.percentage">
						<p>אחוז השמה של החברה: 
							<b>
								<span @click="form.data.offer.fields.percentage.value = payload.data.company.percentage">
									{{payload.data.company.percentage}}
								</span>
							</b>
						</p>
						<div class="horizontal_space"></div>
						<checkbox v-model="is_update_company_percentage">עדכן ל- <b>{{ form.data.offer.fields.percentage.value }}</b></checkbox>
					</div>
				</div>
			</div>
			<div v-if="getPayment" class="form_section">
				<p><b>תשלום לפני מע"מ: </b>{{ getPayment(false) }}</p>
				<p><b>תשלום אחרי מע"מ: </b>{{ getPayment(true) }}</p>
			</div>
			<div class="form_section">
				<p class="bold">הודעה</p>
				<textarea type="text" v-model="form.data.offer.fields.message.value"></textarea>
			</div>
			<div class="form_section">
				<p class="bold">vetting</p>
				<input type="text" v-model="form.data.offer.fields.vetting.value">
			</div>
			<div class="form_section">
				<p class="bold">איתור</p>
				<input type="text" v-model="form.data.offer.fields.strong.value">
			</div>
			<div class="form_section">
				<p class="bold">שליחה</p>
				<input type="text" v-model="form.data.offer.fields.send_by.value">
			</div>
			<div class="form_section">
				<p class="bold">ימים לדרישת תשלום</p>
				<input type="text" v-model="form.data.offer.fields.maturation_days.value" 
					   :class="{ field_error: form.data.offer.fields.maturation_days.has_error }"
					   @focus="form.data.offer.fields.maturation_days.has_error = false">
			</div>
			<div class="form_section">
				<p class="bold">תאריך התחלת עבודה</p>
				<date-time v-model="form.data.offer.fields.start_date.value" :date="form.data.offer.fields.start_date.value" 
					   :class="{ field_error: form.data.offer.fields.start_date.has_error }"></date-time>
			</div>
			<div class="form_section">
				<p class="bold">סטטוס</p>
				<select v-model="form.data.offer.fields.status.value" :class="{ field_error: form.data.offer.fields.status.has_error }">
					<option v-for="status in $offers_helper.getStatuses()" :key="status">{{ status }}</option>
				</select>
			</div>
			<div class="form_section">
				<env-chooser v-model="form.data.offer.fields.env.value" :env="form.data.offer.fields.env.value" :has_error="form.data.offer.fields.env.has_error">
				</env-chooser>
			</div>
			<div class="form_section">
				<p class="bold">Env Offer ID</p>
				<input type="text" v-model="form.data.offer.fields.env_offer_id.value">
			</div>
			<div class="form_section">
				<p class="bold">Next Contact</p>
				<date-time :date="form.data.offer.fields.next_contact.value" v-model="form.data.offer.fields.next_contact.value" />
			</div>
			<div class="form_section">
				<p class="bold">Payment Request Date</p>
				<date-time :date="form.data.offer.fields.payment_request_date.value" v-model="form.data.offer.fields.payment_request_date.value" />
			</div>
			<div class="form_section">
				<p class="bold">Payment Date</p>
				<date-time :date="form.data.offer.fields.payment_date.value" v-model="form.data.offer.fields.payment_date.value" />
			</div>
			<div class="form_section">
				<p class="bold">Invoice Date</p>
				<date-time :date="form.data.offer.fields.invoice_date.value" v-model="form.data.offer.fields.invoice_date.value" />
			</div>
		</div>
		<div class="modal_footer">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading }"
				class="button is-info"
				>Submit</a
			>
		</div>
	</div>
</template>
<script>
	import { mapMutations, mapActions } from 'vuex'
	import DateTime from '@/components/DateTime'
	import CompaniesSearchBox from '@/components/CompaniesSearchBox'
	import Checkbox from '@/components/Checkbox'
	import EnvChooser from '@/components/EnvChooser'
	export default {
		name: 'offer-form',
		props: ['payload'],
		data(){
			return {
				is_update_company_percentage: false,
				is_loading: false,
				form: undefined,
				selected_company_name: '',
			}
		},
		created(){
			this.init()
		},
		methods: {
			init(){
				if (this.payload.is_create) {
					this.setForm({
					  id: '',
					})
					return
				}
				this.$network_utils.getOffer(this.payload.data.id).then(response => {
					this.selected_company_name = response.company.name
					this.setForm(response)
				})
			},
		    setForm (form_data) {
		      this.form = new this.$form({
		        offer: {
		          fields: {
		            applicant_name: {
		              value: form_data.applicant_name,
		              has_error: false,
		              validations: ['Exists']
		            },
		            company_id: {
		              value: form_data.company_id,
		              has_error: false,
		              validations: ['Exists']
		            },
		            salary: {
		              value: form_data.salary,
		              has_error: false,
		              validations: ['Exists', 'Number']
		            },
		            salary_verified: {
		              value: form_data.salary_verified,
		              has_error: false,
		              validations: []
		            },
		            message: {
		              value: form_data.message,
		              has_error: false,
		              validations: []
		            },
		            percentage: {
		              value: form_data.percentage,
		              has_error: false,
		              validations: ['Exists', 'Number']
		            },
		            percentage_verified: {
		              value: form_data.percentage_verified,
		              has_error: false,
		              validations: []
		            },
		            maturation_days: {
		              value: form_data.maturation_days,
		              has_error: false,
		              validations: ['Number']
		            },
		            start_date: {
		              value: form_data.start_date,
		              has_error: false,
		              validations: ['Exists']
		            },
		            status: {
		              value: form_data.status,
		              has_error: false,
		              validations: ['Exists']
		            },
		            env: {
		              value: form_data.env,
		              has_error: false,
		              validations: ['Exists']
		            },
		            env_offer_id: {
		              value: form_data.env_offer_id,
		              has_error: false,
		              validations: []
		            },
		            next_contact: {
   		            value: form_data.next_contact,
		              has_error: false,
		              validations: [] 	
		            },
		            payment_request_date: {
   		            value: form_data.payment_request_date,
		              has_error: false,
		              validations: [] 	
		            },
								vetting: {
									value: form_data.vetting,
									has_error: false,
									validations: []
								},
								strong: {
									value: form_data.strong,
									has_error: false,
									validations: []
								},
								send_by: {
									value: form_data.send_by,
									has_error: false,
									validations: []
								},
		            payment_date: {
   		              value: form_data.payment_date,
		              has_error: false,
		              validations: [] 	
		            },
		            invoice_date: {
   		              value: form_data.invoice_date,
		              has_error: false,
		              validations: [] 	
		            }
		          },
		          request_details: {
		            method: this.payload.is_create ? 'post' : 'put',
		            url: '/offers/' + form_data.id,
		          },
		          is_used: true
		        }
		      })
		    },
		    updateCompanyPercentage(){
				this.$network_utils.updateAccountingCompany({ id: this.payload.data.company_id, percentage: this.form.data.offer.fields.percentage.value }).catch(() => {
					this.showToast('ארעה שגיאה')
				})
		    },
		    submit () {
				let response = this.form.mySubmit()
				if (response === false) {
					return
				}
		    	if(this.is_update_company_percentage){
		    		this.updateCompanyPercentage()
		    	}
				this.is_loading = true
				response.promise.then((response) => {
					this.showToast('עודכן בהצלחה')
					this.is_loading = false
					this.removeModal(this.payload)
		    		if(this.form.data.offer.fields.status.value == 'paid'){
		    			this.openAddDatesSuggestion()
		    		}
				}).catch(() => {
					if(this.payload.is_create){
						this.showToast('ארעה שגיאה - כנראה שיש Offer זהה במערכת')
						this.is_loading = false
						return
					}
					this.showToast('ארעה שגיאה')
				})
		    },
		    openAddDatesSuggestion(){
		    	this.createModal({
		    		designator: 'offer-add-dates-suggestion',
		    		component_name: 'AddOfferDatesSuggestion',
		    		offer_id: this.payload.data.id,
		    		modal_title: 'Add Dates Suggestion'
		    	})
		    },
		    getPayment(plus_vat){
				let salary = this.form.data.offer.fields.salary.value 
				let percentage = this.form.data.offer.fields.percentage.value 
				return this.payload.is_create ? undefined : this.$offers_helper.getPayment({ salary, percentage }, plus_vat)
		    },
				...mapActions('toasts', ['showToast']),
		    ...mapMutations('modals', ['createModal', 'removeModal'])
		},
		components: {
			DateTime,
			CompaniesSearchBox,
			Checkbox,
			EnvChooser
		}
	}
</script>
<style>
	.percentage_different{
		border-radius: 4px;
		margin-right: 10px;
		padding: 10px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
	}
</style>